import React, { Component } from 'react';
import { showUserDeletedNotification } from '../../redux/modules/notifications';
import { Container, Row, Col, Button, Form, Spinner, Modal, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showUserDeletedNotification: () => dispatch(showUserDeletedNotification())
  };
}

class ConnectedUserDetailComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      show: false,
      isLoading: true,
      userNotFound: false,
      removeUser: false,
      removeUserAvailable: false,
      removing: false,
      data: {
        email: { value: '', label: 'Correo', disabled: true },
        firstName: { value: '', label: 'Nombre', disabled: true },
        lastName: { value: '', label: 'Apellido', disabled: true },
        cellPhone: { value: '', label: 'Celular', disabled: true },
        country: { value: '', label: 'País de residencia', disabled: true },
        birthdate: { value: '', label: 'Fecha de nacimiento', disabled: true },
        occupation: { value: '', label: 'Ocupación', disabled: true },
        identification: { value: '', label: 'Identificación', disabled: true },
        isBusiness: { value: false, disabled: true },
        businessName: { value: '', label: 'Razón social', disabled: true },
        nit: { value: '', label: 'NIT', disabled: true },
        industry: { value: '', label: 'Industria', disabled: true },
        linkedBusinessName: { value: '', label: 'Empresa asociada', disabled: true },
        businessRole: { value: '', label: 'Rol', disabled: false, changed: false },
        businessPlan: { value: 'NONE', label: 'Plan', changed: false }
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderInputFields = this.renderInputFields.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.removeUserInputChange = this.removeUserInputChange.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
  }

  removeUser() {
    this.setState({ removeUser: true, show: true });
  }

  async handleRemoveUser() {
    const { id, token, history } = this.props;
    this.setState({ removing: true });

    const removeUserResponse = await fetch(`${apiUrl}/admin/users/remove?token=${token}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id
      })
    });

    const removeUser = await removeUserResponse.json();

    if (removeUser.success) {
      await this.props.showUserDeletedNotification();
      history.push(`/usuarios`);
    }
  }

  removeUserInputChange(event) {
    this.setState({ removeUserAvailable: event.target.value === 'ELIMINAR' });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleInputChange(event) {
    const { data } = this.state;

    const updatedData = {
      ...data, [event.target.name]: {
        ...data[event.target.name],
        value: event.target.value,
        changed: true
      }
    };

    this.setState({ data: updatedData });
  }

  async componentDidMount() {

    const { id, token } = this.props;

    const userResp = await fetch(`${apiUrl}/admin/users/${id}?token=${token}`);
    const userData = await userResp.json();

    if (userData.success) {

      const { data } = this.state;
      const { user } = userData;

      const newData = {};

      Object.keys(data).forEach(key => {
        const original = data[key];
        const newObj = { ...original, value: user[key] };

        newData[key] = newObj;
      });

      this.setState({ data: newData });
    } else {
      this.setState({ userNotFound: true });
    }

    this.setState({ isLoading: false });
  }

  renderInputFields(fields) {

    const { data } = this.state;

    const inputs = Object.keys(fields).map(key => {

      const {
        label,
        value,
        disabled
      } = data[key];

      return (
        <Form.Group key={key} as={Col} md={4}>
          <Form.Label><strong>{label}:</strong></Form.Label>
          {
            disabled ?

              <Form.Control
                type="text"
                defaultValue={value}
                disabled
              /> :

              <Form.Control
                type="text"
                onChange={this.handleInputChange}
                value={value}
                name={key}
                placeholder={label}
              />
          }

        </Form.Group>
      );
    });

    return inputs;
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ submitting: true });

    const { data } = this.state;
    const { businessRole, businessPlan } = data;
    const { token, id } = this.props;

    if (businessRole.changed || businessPlan.changed) {

      const update = { id };
      if (businessRole.changed) update.businessRole = businessRole.value;
      if (businessPlan.changed) update.businessPlan = businessPlan.value;

      const updateUser = await fetch(`${apiUrl}/admin/users/update?token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(update)
      });

      const updateUserJson = await updateUser.json();

      if (updateUserJson.success) this.setState({ show: true, removeUser: false });

    } else {
      this.setState({ show: true, removeUser: false });
    }

    this.setState({ submitting: false });

  }

  render() {

    const {
      isLoading,
      data,
      submitting,
      show,
      userNotFound,
      removeUser,
      removeUserAvailable,
      removing
    } = this.state;

    if (isLoading) return (<AppSpinner />);
    if (userNotFound) return (<h1 className="not-found-error">El usuario especificado no existe.</h1>);

    const {
      isBusiness,
      businessName,
      nit,
      industry,
      businessRole,
      linkedBusinessName,
      businessPlan,
      ...fields
    } = data;

    const businessInfo = { businessName, nit, industry };

    return (
      <div className="detail-info-component user-detail-component">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="user-detail-options">
                <Link to="/usuarios">
                  <Button variant="secondary">
                    Atrás
                  </Button>
                </Link>

                <Button variant="danger" onClick={this.removeUser}>
                  Eliminar usuario
                </Button>
              </div>

            </Col>

            <Col xs={12}>

              <Form onSubmit={this.handleSubmit}>
                <Form.Row>
                  {this.renderInputFields(fields)}
                  {isBusiness.value && this.renderInputFields(businessInfo)}
                  {
                    isBusiness.value &&
                    <Form.Group as={Col} xs={4}>
                      <Form.Label><strong>Plan:</strong></Form.Label>
                      <Form.Control
                        as="select"
                        name="businessPlan"
                        value={businessPlan.value}
                        onChange={this.handleInputChange}
                      >
                        <option value="NONE">Ninguno</option>
                        <option value="PREMIUM">Premium</option>
                      </Form.Control>
                    </Form.Group>
                  }
                </Form.Row>

                <Col xs={12}><hr /></Col>

                {
                  businessRole.value ?
                    <Form.Row>
                      <Form.Group as={Col} xs={4}>
                        <Form.Label><strong>Empresa asociada:</strong></Form.Label>
                        <Form.Control
                          defaultValue={linkedBusinessName.value}
                          disabled={true}
                        />
                      </Form.Group>

                      <Form.Group as={Col} xs={4}>
                        <Form.Label><strong>Rol:</strong></Form.Label>
                        <Form.Control
                          as="select"
                          name="businessRole"
                          value={businessRole.value}
                          onChange={this.handleInputChange}
                        >
                          <option value="EMPLOYEE">Empleado</option>
                          <option value="BUSINESS_ADMIN">Administrador</option>
                        </Form.Control>
                      </Form.Group>
                    </Form.Row> :

                    !isBusiness.value ?
                      <Form.Row>
                        <Form.Group as={Col} xs={4}>
                          <Form.Label><strong>Empresa asociada:</strong></Form.Label>
                          <Form.Control
                            defaultValue="No aplica"
                            disabled={true}
                          />
                        </Form.Group>

                        <Form.Group as={Col} xs={4}>
                          <Form.Label><strong>Rol:</strong></Form.Label>
                          <Form.Control
                            defaultValue="No aplica"
                            disabled={true}
                          />
                        </Form.Group>
                      </Form.Row> : null
                }

                <div className="form-buttons">

                  <Link to="/usuarios">
                    <Button variant="secondary">
                      Atrás
                    </Button>
                  </Link>

                  <Button type="submit" className="nibi-btn">
                    {
                      submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Guardar cambios'
                    }
                  </Button>
                </div>

              </Form>

            </Col>
          </Row>
        </Container>
        <Modal show={show} onHide={this.handleClose}>
          {
            removeUser ?
              <>
                <Modal.Header closeButton>
                  <Modal.Title>Eliminar usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {
                    removing ? <AppSpinner /> :
                      <>
                        <Alert variant="warning">
                          <p>
                            Esta acción no se puede deshacer.
                            El usuario será eliminado permanentemente.
                          </p>
                        </Alert>

                        <Form.Row>
                          <Form.Group as={Col} xs={12}>
                            <p>
                              Por favor excriba ELIMINAR para confirmar.
                            </p>
                            <Form.Control
                              type="text"
                              onChange={this.removeUserInputChange}
                            />
                          </Form.Group>
                          <Col className="modal-btn-col" xs={12}>
                            <Button variant="secondary" onClick={this.handleClose}>
                              Cancelar
                            </Button>
                            <Button variant="danger" disabled={!removeUserAvailable} onClick={this.handleRemoveUser}>
                              Eliminar
                            </Button>
                          </Col>
                        </Form.Row>
                      </>
                  }

                </Modal.Body>
              </> :
              <>
                <Modal.Header closeButton>
                  <Modal.Title>Cambios guardados</Modal.Title>
                </Modal.Header>
                <Modal.Body>Se han guardado los cambios</Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" onClick={this.handleClose}>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </>
          }
        </Modal>
      </div>
    );
  }
}

const UserDetailComponent = connect(select, mapDispatchToProps)(ConnectedUserDetailComponent);

export default UserDetailComponent;
